/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionContact } from '../../models/subscription-contact';

export interface GetSubscriptionContact$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  contactUid: string;
}

export function getSubscriptionContact(http: HttpClient, rootUrl: string, params: GetSubscriptionContact$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionContact>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionContact.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('contactUid', params.contactUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionContact>;
    })
  );
}

getSubscriptionContact.PATH = '/custom/subscriptions/{uid}/contacts/{contactUid}';
